/**
 * Full-screen "New version — refresh" panel. No auto-reload loops
 * (the wp7 spec is explicit about this) — the user hits the button.
 */

import type { ReactElement } from "react";
import { useStore } from "../store/context.js";

export function ProtocolMismatchPanel(): ReactElement {
  const { state } = useStore();
  return (
    <div
      data-testid="protocol-mismatch"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(11, 15, 20, 0.95)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 16,
        zIndex: 100,
        color: "#fff",
      }}
    >
      <h1 style={{ margin: 0 }}>New version available</h1>
      <p style={{ opacity: 0.75, maxWidth: 480, textAlign: "center" }}>
        The server is running a newer protocol
        {state.connection.serverVersion === null
          ? ""
          : ` (v${String(state.connection.serverVersion)})`}
        . Refresh the page to reconnect.
      </p>
      <button
        type="button"
        data-testid="protocol-mismatch-refresh"
        onClick={() => {
          window.location.reload();
        }}
        style={{
          padding: "10px 24px",
          background: "#3aa675",
          color: "#fff",
          border: "none",
          borderRadius: 4,
        }}
      >
        Refresh
      </button>
    </div>
  );
}
